import HotelBookingsCard from './HotelBookingsCard';
import TravelBookingsCard from './TravelBookingsCard';
import ItineraryCard from './ItineraryCard';
import ImportantDocumentsCard from './ImportantDocumentsCard';

const TourBookingsSection = ({
  voucher,
  id,
  setVoucher,
  onUpdateVoucher
}) => {
  return (
    <div className="vc-zone">
      <div className="vc-zone-label">
        <span className="vc-tag">Tour Bookings</span>
        <span className="vc-sub">tap any stay or travel to view details &amp; edit</span>
        <span className="vc-rule"></span>
      </div>

      <div className="vc-grid vc-g-3">
        {/* Hotels */}
        <HotelBookingsCard 
          voucher={voucher} 
          onUpdateVoucher={onUpdateVoucher} 
        />

        {/* Travels (Flights / Trains / Buses / Cabs) */}
        <TravelBookingsCard 
          voucher={voucher} 
          onUpdateVoucher={onUpdateVoucher} 
        />

        {/* Itinerary — navigates to full-page itinerary */}
        <ItineraryCard voucher={voucher} id={id} />
      </div>

      {/* Important Documents Full-Width Card */}
      <ImportantDocumentsCard voucher={voucher} id={id} setVoucher={setVoucher} />
    </div>
  );
};

export default TourBookingsSection;
